import { useMemo } from "react";
import { PropertyAPIPromiseClient } from "../../gen/witbooking/backoffice/property/v1/property_api_grpc_web_pb";
import { GetPropertyChildrenRequest } from "../../gen/witbooking/backoffice/property/v1/property_api_pb";
import { useGrpcClient, usePropertyScopedGrpcCall } from "../../lib/grpc";

export function usePropertyApi() {
  const grpcClient = useGrpcClient(PropertyAPIPromiseClient);
  const getPropertyChildrenCall = usePropertyScopedGrpcCall(
    grpcClient,
    grpcClient.getPropertyChildren
  );

  return useMemo(
    () => ({
      getPropertyChildren: async (propertyTicker: string) => {
        const response = await getPropertyChildrenCall(
          propertyTicker,
          new GetPropertyChildrenRequest()
        );
        return response.getPropertyTickersList();
      },
    }),
    [getPropertyChildrenCall]
  );
}
